module.exports = __webpack_public_path__ + "static/media/logo_nanoinstitute.936a39f7.jpg";